

module.exports = __webpack_require__.stylable.create(
    "PlanName3511018268",
    {"classes":{"root":"PlanName3511018268__root","planTitle":"PlanName3511018268__planTitle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "PlanName3511018268",
    null
);
